import type { AssistantWebsiteResponse } from "@/types/assistant";
import type { MaybeRef } from "vue";

export function getAssistantSingleCompetitorQueryKey(id: string) {
  return ["assistant-data", "competitor-single", id];
}

export function useAssistantSingleCompetitorRequest(
  id: string,
  isDisabled?: MaybeRef<boolean>
) {
  const enabled = computed(() => {
    return !!id && (isDisabled === undefined || !toValue(isDisabled));
  });
  const query = useQuery({
    queryKey: getAssistantSingleCompetitorQueryKey(id),
    queryFn: async () => {
      if (!id || typeof id !== "string") throw new Error("Missing id");
      const response = await useGetRequest<AssistantWebsiteResponse>("/account/data", {
        params: {
          itemId: id,
        },
      });
      return response?.data || null;
    },
    staleTime: 3 * MINUTE,
    enabled,
  });
  return query;
}
